export const GET_BET_DETAIL_START='GET_BET_DETAIL_START';
export const GET_BET_DETAIL_SUCCESS='GET_BET_DETAIL_SUCCESS';
export const GET_BET_DETAIL_FAIL='GET_BET_DETAIL_FAIL';

